// extracted by mini-css-extract-plugin
export default {"footer":"U3elg","logo":"nhh8W","copyright":"_1kXxA","links":"_8pVhp"};